import { createGlobalStyle, css } from 'styled-components';
import palette from './palette';

// Color rules only. Dimensions and semantic danger/success/warning styles stay with their components.
const GlobalPaletteStyles = createGlobalStyle`
  :root {
    --aidose-primary: ${palette.primary};
    --aidose-primary-soft: ${palette.primarySoft};
    --aidose-secondary: ${palette.secondary};
    --aidose-text: ${palette.text};
    --aidose-border: ${palette.border};
    --aidose-canvas: ${palette.canvas};
  }
  ${({ theme }) =>
    !theme.darkMode &&
    css`
      body {
        background-color: ${palette.canvas};
        color: ${palette.text};
      }
      .ant-layout {
        background-color: ${palette.canvas};
      }
      .ant-layout-header,
      .ant-layout-footer {
        background-color: ${palette.surface};
      }
      .ant-btn-primary:not(:disabled):not(.ant-btn-dangerous):not(.ant-btn-background-ghost) {
        background: ${palette.primary} !important;
        border-color: ${palette.primary} !important;
        color: ${palette.surface} !important;
      }
      .ant-btn-primary:not(:disabled):not(.ant-btn-dangerous):not(.ant-btn-background-ghost):hover {
        background: ${palette.primaryHover} !important;
        border-color: ${palette.primaryHover} !important;
      }
      .ant-btn-link:not(:disabled):not(.ant-btn-dangerous) {
        color: ${palette.primary};
      }
      .ant-table {
        color: ${palette.text};
        background-color: ${palette.surface};
      }
      .ant-table-wrapper .ant-table-thead > tr > th {
        background-color: ${palette.primarySoft} !important;
        color: ${palette.heading} !important;
        font-weight: 400;
        line-height: 1.5;
        text-transform: none;
        border-bottom: 1px solid ${palette.border} !important;
      }
      .ant-table-wrapper .ant-table-thead > tr > th.ant-table-column-has-sorters:hover {
        background-color: ${palette.primaryBorder} !important;
      }
      .ant-table-wrapper .ant-table-thead .ant-table-column-sorter,
      .ant-table-wrapper .ant-table-thead .ant-table-filter-trigger {
        color: ${palette.muted};
      }
      .ant-table-wrapper .ant-table-thead .ant-table-filter-trigger.active,
      .ant-table-wrapper .ant-table-thead .ant-table-filter-trigger:hover,
      .ant-table-wrapper .ant-table-thead .ant-table-column-sorter-up.active,
      .ant-table-wrapper .ant-table-thead .ant-table-column-sorter-down.active {
        color: ${palette.primary};
      }
      .ant-table-tbody > tr > td {
        border-bottom-color: ${palette.divider};
      }
      .ant-table-tbody > tr.ant-table-row:hover > td {
        background-color: ${palette.primarySoft};
      }
      .ant-table-column-sorter-up.active,
      .ant-table-column-sorter-down.active {
        color: ${palette.primary};
      }
      .ant-modal-content,
      .ant-modal-header,
      .ant-drawer-content,
      .ant-drawer-header {
        background-color: ${palette.surface};
      }
      .ant-modal-title,
      .ant-drawer-title,
      .ant-card-head-title {
        color: ${palette.heading};
      }
      .ant-modal-header,
      .ant-modal-footer,
      .ant-drawer-header,
      .ant-card-head {
        border-color: ${palette.divider};
      }
      .ant-input:not(.ant-input-status-error):not(.ant-input-status-warning):not(:disabled),
      .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-status-error):not(
          .ant-input-affix-wrapper-status-warning
        ):not(.ant-input-affix-wrapper-disabled) {
        color: ${palette.text};
      }
      .ant-input::placeholder {
        color: ${palette.placeholder};
      }
      .ant-tabs-tab:not(.ant-tabs-tab-disabled) {
        color: ${palette.heading};
      }
      .ant-tabs-tab:not(.ant-tabs-tab-disabled):hover {
        color: ${palette.primary};
      }
      .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn,
      .ant-menu-item-selected a {
        color: ${palette.primary};
      }
      .ant-menu:not(.ant-menu-dark) .ant-menu-item-selected {
        background-color: ${palette.primarySoft};
      }
      .ant-pagination-item-active {
        border-color: ${palette.primary};
      }
      .ant-pagination-item-active a,
      .ant-radio-checked .ant-radio-inner {
        color: ${palette.primary};
      }
      .ant-checkbox-checked .ant-checkbox-inner,
      .ant-switch-checked {
        background-color: ${palette.primary};
        border-color: ${palette.primary};
      }
    `}
`;
export default GlobalPaletteStyles;
